/**
 * Monthly multiplier applied to the Pititim module price.
 *
 * Múltiplo mensal definido pela coordenação — confirmado com o cliente em 04/09/2026.
 * Aplicado igualmente para qualquer quantidade de módulos (1 a 10), não é um valor por faixa.
 */
export const PITITIM_MONTHLY_MULTIPLIER = 4.5;

/**
 * Calculates the monthly Pititim price for a given number of contracted
 * modules, applying the module price, the progressive discount (%) and the
 * monthly multiplier.
 *
 * @param {number} modules - Number of contracted modules (1 to 10)
 * @param {number} price - Full price per module, in cents
 * @param {number} discount - Discount percentage (0 to 100) for the given amount of modules
 * @returns {number} Monthly price, in cents, rounded to the nearest integer
 */
export function calculateMonthlyPititimPrice(modules, price, discount) {
  return Math.round(
    modules * price * (1 - discount / 100) * PITITIM_MONTHLY_MULTIPLIER
  );
}
